import * as React from 'react';
import { useState } from 'react';
import styled, { css } from 'styled-components';

import type { DescriptiveItem } from 'components/common/PaginatedItemOverview';
import useCollection from 'collections/hooks/useCollection';
import { Spinner, IconButton, ConfirmDialog } from 'components/common';
import Routes from 'routing/Routes';
import { Link } from 'components/common/router';

type Props = {
  item: DescriptiveItem;
  onDeleteItem: (item: DescriptiveItem) => void;
};

const ActionTd = styled.td(
  ({ theme }) => css`
    && {
      display: flex;
      justify-content: flex-end;
      padding-right: ${theme.spacings.sm};
    }
  `,
);

const EntityCollectionItem = ({ item, onDeleteItem }: Props) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const { isLoading, data: collection } = useCollection(item.name);

  const toggleShowConfirmDelete = () => {
    setShowConfirmDelete(!showConfirmDelete);
  };

  const handleDelete = () => onDeleteItem(item);

  const deleteButton =
    typeof onDeleteItem === 'function' ? (
      <IconButton onClick={() => setShowConfirmDelete(true)} name="close" title={`Remove ${collection?.title}`} />
    ) : null;

  if (isLoading) {
    <Spinner />;
  }

  return (
    <tr>
      <td>
        <Link to={Routes.pluginRoute('COLLECTIONS_COLLECTIONID')(collection?.id)}>{collection?.title}</Link>
      </td>
      <td>{collection?.description}</td>
      {deleteButton && (
        <ActionTd>
          {deleteButton}{' '}
          {showConfirmDelete && (
            <ConfirmDialog
              show={showConfirmDelete}
              onConfirm={handleDelete}
              onCancel={toggleShowConfirmDelete}
              title="Are you sure?">
              <>
                <p>
                  You are about to remove this collection from the list of collections that will be assigned to entity
                  created by users.
                </p>
                <p>Do you wish to continue?</p>
              </>
            </ConfirmDialog>
          )}
        </ActionTd>
      )}
    </tr>
  );
};

export default EntityCollectionItem;
